export default "/static/media/icon-skywalker.869a3fd5.svg";